import { FormGroup, RadioButton } from '@salecycle/ui-component-library';
import * as React from 'react';
import { connect } from 'react-redux';
import { NoActiveMarketingPermission } from 'entities/campaign/rules/NoActiveMarketingPermission';
import { Actions } from 'sections/campaigns/state/rulesets';
import { OwnProps, Props } from './props';
import { ReshowSelector } from './ReshowSelector';

export type FormProps = Props<NoActiveMarketingPermission>;

const aMonthInMilliseconds = 28 * 24 * 60 * 60 * 1000;

export const Form: React.FC<FormProps> = (props: FormProps) => {
  const isShowAgainAfterDefined = undefined !== props.rule.showAgainAfter && null !== props.rule.showAgainAfter;
  const isReshowPeriodically = isShowAgainAfterDefined && props.rule.showAgainAfter > 0;

  const updateShowAgain = (duration: number) =>
    props.update(props.rulesetId, props.ruleIndex, {
      ...props.rule,
      showAgainAfter: duration,
    });

  const activateNoReShow = () => updateShowAgain(undefined);
  const activatePeriodically = () => {
    if (!isReshowPeriodically) {
      updateShowAgain(aMonthInMilliseconds);
    }
  };
  const activateEveryTime = () => updateShowAgain(0);

  return (
    <div data-testid="NoActiveMarketingPermission">
      <div>
        We will only show this message to users who haven&apos;t given us permission to send them marketing messages.
      </div>

      <hr />

      <div>Show this message to each user:</div>

      <FormGroup>
        <RadioButton selected={!isShowAgainAfterDefined} onClick={activateNoReShow} label="Display once" />
        <RadioButton selected={isReshowPeriodically} onClick={activatePeriodically} label="Display periodically" />
        {isReshowPeriodically && <ReshowSelector duration={props.rule.showAgainAfter} onChange={updateShowAgain} />}
        <RadioButton
          selected={isShowAgainAfterDefined && !isReshowPeriodically}
          onClick={activateEveryTime}
          label="Display every time"
        />
      </FormGroup>
    </div>
  );
};

export default connect<{}, {}, OwnProps>(null, { update: Actions.editRule })(Form);
